import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "./ui/Button";
import { SectionTag } from "./ui/SectionTag";
import { PRODUCTS } from "../constants";
import { ProductCard } from "./ProductCard";
import { Hero } from "./ProductHero";

export const ProductsPage: React.FC = () => {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate("/contact");
  };

  const handleLearnMore = (productName: string) => {
    // Find product by name to get the slug
    const product = PRODUCTS.find((p) => {
      const normalizedName = productName
        .toLowerCase()
        .replace(/\s*\(.*?\)\s*/g, "")
        .trim();
      const normalizedProductName = p.name.toLowerCase().trim();
      const fullProductName = p.subtitle
        ? `${p.name} ${p.subtitle}`.toLowerCase().trim()
        : normalizedProductName;

      return (
        normalizedName === normalizedProductName ||
        normalizedName === fullProductName ||
        normalizedName.includes(normalizedProductName) ||
        normalizedProductName.includes(normalizedName)
      );
    });

    if (product) {
      navigate(`/products/${product.id}`);
    } else {
      // Fallback: create slug from product name
      const slug = productName
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[()]/g, "");
      navigate(`/products/${slug}`);
    }
  };

  return (
    <div className="bg-white min-h-screen">
      <Hero onContactClick={handleContactClick} />
      <div className="pt-12 pb-12 lg:pt-16 lg:pb-16 bg-white">
        <div className="container mx-auto w-[90%] lg:w-[70%]">
          {/* Header Section */}
          <div className="flex flex-col lg:flex-row justify-between items-start mb-12 lg:mb-16 gap-4 md:gap-12">
            <div className="">
              <SectionTag className="!mb-2 font-raleway">PRODUCT</SectionTag>
              <h2
                className="text-3xl md:text-heading-large font-open-sans-hebrew font-bold bg-gradient-to-r
                from-[#e20016] from-[0%]
                via-[#712f59] via-[40%]
                to-[#005d9c] to-[100%] bg-clip-text text-transparent mt-2 md:mt-6"
              >
                Explore Our Complete Plywood{" "}
                <br className="hidden md:block" />
                Range For Every Need
              </h2>
            </div>

            <div className="flex flex-col items-start lg:items-start gap-4 md:gap-8 max-w-sm pt-0 lg:pt-0">
              <p className="text-gray-500 text-body lg:text-left font-raleway">
                Engineered plywood crafted for marine, fire-retardant,
                structural, and interior applications with exceptional
                durability and stability.
              </p>
              <Button
                variant="red"
                className="bg-[#F5F5F5] border-none px-6 py-3 rounded-lg text-body font-medium hover:bg-black transition-colors font-raleway"
              >
                Explore Croma Ply
              </Button>
            </div>
          </div>

          {/* Product List */}

          <div className="space-y-12 mx-auto">
            {PRODUCTS.map((product, index) => (
              <ProductCard
                key={product.id}
                name={product.name}
                description={product.description}
                specs={product.specs}
                tags={product.tags}
                image={product.image}
                onLearnMoreClick={() => handleLearnMore(product.name)}
                index={index}
                enableAnimation={false}
                scrollable={false}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
